import {Component, Input} from '@angular/core';
import {ROLE_METADATA} from 'app/permissions/role-metadata';
import {DepartureRole} from 'app/permissions/types';

@Component({
  selector: 'das-template-role',
  templateUrl: './template-role.component.html',
  styleUrls: ['./template-role.component.scss']
})
export class TemplateRoleComponent {
  public displayString: string = '';

  @Input() set role(role: DepartureRole) {
    this.displayString = ROLE_METADATA[role].displayName;
  }
}
